module.exports = __webpack_public_path__ + "e7c172e34915ba527addc69b163fa743.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/logo-yellow.svg
// module id = 1202
// module chunks = 74